import icons from '../../options/icons';
import './style.scss';
import { useState } from '@wordpress/element';

const IconPicker = ({ label, selectedIcon, changeIcon }) => {
	const [showIcons, setShowIcons] = useState(false);
	const [search, setSearch] = useState('');

	const closePopup = () => setShowIcons(false);

	return (
		<div className="gutnm-icon-picker">
			<p className="gutnm-label">{label}</p>
			<div className="gutnm-icons-picker">
				<button
					className="gutnm-icon-header"
					onClick={() => setShowIcons(true)}
				>
					<span className="gutnm-selected-icon">
						{icons[selectedIcon]}
					</span>
				</button>

				{showIcons && (
					<div className="gutnm-custom-popup-overlay" onClick={closePopup}>
						<div
							className="gutnm-custom-popup-content"
							onClick={(e) => e.stopPropagation()}
						>
							<div className="gutnm-icons-container">
								<div className="search">
									<input
										type="text"
										placeholder="Search Icon"
										value={search}
										onChange={(e) => setSearch(e.target.value)}
									/>
								</div>
								<div className="icon-list">
									{Object.keys(icons)
										.filter((icon) =>
											icon.toLowerCase().includes(search.toLowerCase())
										)
										.map((icon, index) => (
											<button
												className={`gutnm-icon ${
													icon === selectedIcon ? 'active-icon' : ''
												}`}
												key={index}
												onClick={() => {
													changeIcon(icon);
													closePopup();
												}}
											>
												{icons[icon]}
											</button>
										))}
								</div>
								<button className="icon-close-button" onClick={closePopup}>
								<svg viewBox="0 0 320.591 320.591"><g><path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"></path><path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"></path></g></svg>
								</button>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default IconPicker;
